export class UploadClientDocType {
    docType: string;
}

export const UploadClientDocTypeValues: UploadClientDocType[] = [
    { docType: 'Contratto' },
    { docType: 'Privacy' },
    { docType: 'Visura Camerale' },
    { docType: 'Altro' }
]